import React from 'react';
import { Building2, User, Mail, Phone } from 'lucide-react';
import { ProfileStatusBadge } from '../profiles/ProfileStatusBadge';
import { IntelligenceProfile } from '../../types';

interface ProfileCardHeaderProps {
  profile: IntelligenceProfile;
  className?: string;
}

export const ProfileCardHeader: React.FC<ProfileCardHeaderProps> = ({
  profile,
  className = ""
}) => {
  return (
    <div className={`flex items-start justify-between ${className}`}>
      <div className="flex-1">
        <h3 className="text-xl mb-3 flex items-center font-semibold">
          <Building2 className="h-5 w-5 mr-3 text-blue-600" />
          {profile.company_name}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 text-sm text-gray-600">
          <span className="flex items-center">
            <User className="h-4 w-4 mr-2 text-gray-400" />
            {profile.contact_name}
          </span>
          <span className="flex items-center">
            <Mail className="h-4 w-4 mr-2 text-gray-400" />
            {profile.email}
          </span>
          {profile.phone && (
            <span className="flex items-center">
              <Phone className="h-4 w-4 mr-2 text-gray-400" />
              {profile.phone}
            </span>
          )}
        </div>
      </div>
      <div className="flex flex-col items-end space-y-2">
        <ProfileStatusBadge 
          status={profile.onboarding_status} 
          type="onboarding" 
        />
        {profile.submission && profile.submission.processing_status !== profile.onboarding_status && (
          <ProfileStatusBadge 
            status={profile.submission.processing_status}
            type="submission"
          />
        )}
      </div>
    </div>
  );
};